import React from 'react';
import AgentsColumns from './AgentsColumns';
import { useSearchStore } from '../../store/store';
import PropTypes from 'prop-types';
import { getEffectiveTabMode } from '../helpers/agentProductionHelpers';

const MetricsSelector = ({ columns, setColumns, tabMode, customSettings }) => {

    const effectiveTabMode = getEffectiveTabMode(tabMode, customSettings?.isPeriodLast12Months);

    const { selectedColumnIds } = useSearchStore(state => ({
        selectedColumnIds: state[state.selectedModule]?.selectedColumnIds?.[effectiveTabMode]?.columns,
    }));

    const defaultColumns = selectedColumnIds
        ? columns.map(column => ({
            ...column,
            isDisplayed: selectedColumnIds.includes(column.id) || selectedColumnIds.includes(column.parentColumnId),
        }))
        : columns;

    const setSelectedColumnIds = selectedColumnIds => {
        const revisedColumns = [...columns];
        revisedColumns.forEach(column => {
            const foundColumn = selectedColumnIds.find(id => id === column.id || id === column.parentColumnId);
            column.isDisplayed = !!foundColumn;
        });
        setColumns(revisedColumns);
    };

    return <>
        <AgentsColumns defaultColumns={defaultColumns}
                       tabMode={tabMode}
                       inputIdPrefix='metrics-selector'
                       customSettings={customSettings}
                       setParentColumnIds={setSelectedColumnIds} />
    </>;
};

MetricsSelector.propTypes = {
    columns: PropTypes.arrayOf(PropTypes.object),
    setColumns: PropTypes.func,
    tabMode: PropTypes.string,
    customSettings: PropTypes.object
};

export default MetricsSelector;
